import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import css from 'styled-jsx/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const { className, styles } = css.resolve`
  .modal-dialog {
    margin-top: 75px;
  }
`;

export default function MobileRulesFiltersModal(props) {
  const { isOpen, toggleModal, searchTerm, handleSearch, resource } = props;

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggleModal(!isOpen)}
      className={className}
      backdropClassName="bg-transparent"
    >
      <ModalBody>
        <div className="input-group input-group-sm">
          <div className="input-group-prepend">
            <span className="input-group-text" id="searchByNameIcon">
              <button className="btn btn-link p-0 text-reset">
                <FontAwesomeIcon
                  className="text-text-light-gray"
                  icon={faSearch}
                  size="sm"
                />
              </button>
            </span>
          </div>
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearch}
            className="form-control"
            aria-label={`Search by ${resource} Name`}
            aria-describedby="searchByNameIcon"
            placeholder={`search by ${resource} name`}
          />
        </div>
      </ModalBody>
      {styles}
    </Modal>
  );
}

MobileRulesFiltersModal.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  searchTerm: PropTypes.string,
  handleSearch: PropTypes.func,
  resource: PropTypes.oneOf(['rule', 'job', 'asset']),
};
